import request from './request'
// 新闻列表
export function getNews(data){
    let url = "/api/Notice/PageListAsync";
    return request({
        url: url,
        method: 'post',
        dataType: 'json',
        data
    });
}

// 获取新闻详情
export function getNewsContent(data){
    let url = "/api/Notice/GetAsync";
    return request({
        url: url,
        method: 'post',
        dataType: 'json',
        data
    });
}


// WEBPACK FOOTER //
// ./src/assets/js/modules/newsApi.js